import SimpleCardListing from '@package/components/Blocks/Listing/variations/SimpleCardListing';
import NewsCardListing from '@package/components/Blocks/Listing/variations/NewsCardListing';
import PhotogalleryListing from '@package/components/Blocks/Listing/variations/PhotogalleryListing';
import MosaicCardListing from '@package/components/Blocks/Listing/variations/MosaicCardListing';
import DownloadListing from '@package/components/Blocks/Listing/variations/DownloadListing';
import SearchResults from '@package/components/Blocks/Listing/variations/SearchResults';
import JobPostingListing from '@package/components/Blocks/Listing/variations/JobPostingListing';

import getDefaultSchema from '@package/config/Blocks/schemas/listing-variations/default-schema';
import getSimpleCardVariationSchema from '@package/config/Blocks/schemas/listing-variations/simple-card-variation-schema';
import getNewsCardVariationSchema from '@package/config/Blocks/schemas/listing-variations/news-card-variation-schema';
import getPhotogalleryVariationSchema from '@package/config/Blocks/schemas/listing-variations/photogallery-variation-schema';
import getMosaicVariationSchema from '@package/config/Blocks/schemas/listing-variations/mosaic-card-variation-schema';
import getDownloadVariationSchema from '@package/config/Blocks/schemas/listing-variations/download-list-variation-schema';
import getSearchResultsVariationSchema from '@package/config/Blocks/schemas/listing-variations/search-results-variation-schema';
import getJobPostingVariationSchema from '@package/config/Blocks/schemas/listing-variations/jobposting-list-variation-schema';
import { removeListingVariation } from '@package/config/Blocks/schemas/utils';
import { addAltText } from '@package/config/Blocks/schemas/addAltText';

import divideHorizontalSVG from '@plone/volto/icons/divide-horizontal.svg';
import BreakView from '@package/components/Blocks/Break/View';
import BreakEdit from '@package/components/Blocks/Break/Edit';

import userSVG from '@plone/volto/icons/user.svg';
import AuthorView from '@package/components/Blocks/Author/View';
import AuthorEdit from '@package/components/Blocks/Author/Edit';

import infoSVG from '@plone/volto/icons/info.svg';
import InfoboxView from '@package/components/Blocks/InfoBox/View';
import InfoboxEdit from '@package/components/Blocks/InfoBox/Edit';

import testo1SVG from '@package/icons/testo1.svg';
import Testo1View from '@package/components/Blocks/Testo1/View';
import Testo1Edit from '@package/components/Blocks/Testo1/Edit';

import testo5SVG from '@package/icons/testo5.svg';
import Testo5View from '@package/components/Blocks/Testo5/View';
import Testo5Edit from '@package/components/Blocks/Testo5/Edit';

import testo4SVG from '@package/icons/testo4.svg';
import Testo4View from '@package/components/Blocks/Testo4/View';
import Testo4Edit from '@package/components/Blocks/Testo4/Edit';

import testo6SVG from '@package/icons/testo6.svg';
import Testo6View from '@package/components/Blocks/Testo6/View';
import Testo6Edit from '@package/components/Blocks/Testo6/Edit';

import testo7SVG from '@package/icons/testo7.svg';
import Testo7View from '@package/components/Blocks/Testo7/View';
import Testo7Edit from '@package/components/Blocks/Testo7/Edit';

import highlightedContentSVG from '@package/icons/testo7.svg';
import HighlightedContentView from '@package/components/Blocks/HighlightedContent/View';
import HighlightedContentEdit from '@package/components/Blocks/HighlightedContent/Edit';

import sliderSVG from '@plone/volto/icons/slider.svg';
import SliderView from '@package/components/Blocks/Slider/View';
import SliderEdit from '@package/components/Blocks/Slider/Edit';

import numbersSVG from '@package/icons/numeri.svg';
import NumbersView from '@package/components/Blocks/Numbers/View';
import NumbersEdit from '@package/components/Blocks/Numbers/Edit';

import moreSVG from '@plone/volto/icons/more.svg';
import BreadcrumbsView from '@package/components/Blocks/Breadcrumbs/View';
import BreadcrumbsEdit from '@package/components/Blocks/Breadcrumbs/Edit';

import ViewHTMLBlock from '@package/components/Blocks/HTML/View';
import EditHTMLBlock from '@package/components/Blocks/HTML/Edit';

import signSeparatorSVG from '@package/icons/separatore-segno.svg';
import SignedSeparatorView from '@package/components/Blocks/SignedSeparator/View';
import SignedSeparatorEdit from '@package/components/Blocks/SignedSeparator/Edit';

import iconsNumbersSVG from '@package/icons/numeri-icone.svg';
import IconsAndNumbersView from '@package/components/Blocks/IconsAndNumbers/View';
import IconsAndNumbersEdit from '@package/components/Blocks/IconsAndNumbers/Edit';

import iconsAndTextSVG from '@package/icons/icons_and_text.svg';
import IconsAndTextView from '@package/components/Blocks/IconsAndText/View';
import IconsAndTextEdit from '@package/components/Blocks/IconsAndText/Edit';

import imageColumnsSVG from '@package/icons/image_columns.svg';
import ImageColumnsView from '@package/components/Blocks/ImageColumns/View';
import ImageColumnsEdit from '@package/components/Blocks/ImageColumns/Edit';

import ImageViewerView from '@package/components/Blocks/ImageViewer/View';
import ImageViewerEdit from '@package/components/Blocks/ImageViewer/Edit';

import linkSVG from '@plone/volto/icons/link.svg';
import LinkedItemsView from '@package/components/Blocks/LinkedItems/View';
import LinkedItemsEdit from '@package/components/Blocks/LinkedItems/Edit';
import TextEdit from '@package/components/Blocks/Text/Edit';
import TextView from '@package/components/Blocks/Text/View';
import JobPostingCTAsView from '@package/components/Blocks/JobPostingCTAs/View';
import JobPostingCTAsEdit from '@package/components/Blocks/JobPostingCTAs/Edit';

import JobPostingEdit from '@package/components/Blocks/JobPosting/Edit';
import JobPostingView from '@package/components/Blocks/JobPosting/View';

import tabsSVG from '@package/icons/tabs.svg';
import TabsView from '@package/components/Blocks/Tabs/View';
import TabsEdit from '@package/components/Blocks/Tabs/Edit';

import calendarSVG from '@plone/volto/icons/calendar.svg';
import PageMetadataView from '@package/components/Blocks/PageMetadata/View';
import PageMetadataEdit from '@package/components/Blocks/PageMetadata/Edit';

import tagSVG from '@plone/volto/icons/tag.svg';
import PageTagView from '@package/components/Blocks/PageTag/View';
import PageTagEdit from '@package/components/Blocks/PageTag/Edit';

import RelatedItemsView from '@package/components/Blocks/RelatedItems/View';
import RelatedItemsEdit from '@package/components/Blocks/RelatedItems/Edit';

import downSVG from '@package/icons/arrow-down.svg';
import rightSVG from '@package/icons/arrow-right.svg';
import upSVG from '@package/icons/arrow-up.svg';

import { updateSearchBlockExtensions } from '@package/config/Blocks/schemas/searchSchema';

export const RaiWayBlocks = (config) => {
  const defaultBlocksConfig = {
    restricted: false,
    mostUsed: false,
    security: {
      addPermission: [],
      view: [],
    },
    sidebarTab: 1,
  };

  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,
    title: { ...config.blocks.blocksConfig.title, restricted: false }, //lo si può aggiungere sempre
    text: {
      ...config.blocks.blocksConfig.text,
      edit: TextEdit,
      view: TextView,
      sidebarTab: 1,
    },
    breadcrumbs: {
      ...defaultBlocksConfig,
      id: 'breadcrumbs',
      title: 'Briciole di pane',
      icon: moreSVG,
      group: 'text',
      view: BreadcrumbsView,
      edit: BreadcrumbsEdit,
      restricted: true,
      sidebarTab: 1,
    },
    author: {
      id: 'author',
      title: 'Autore',
      icon: userSVG,
      group: 'common',
      view: AuthorView,
      edit: AuthorEdit,
      restricted: true,
      mostUsed: false,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },
    related_items: {
      id: 'related_items',
      title: 'Contenuti correlati',
      icon: moreSVG,
      group: 'common',
      view: RelatedItemsView,
      edit: RelatedItemsEdit,
      restricted: true,
      mostUsed: false,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },
    highlighted_content: {
      id: 'highlighted_content',
      title: 'Contenuto in evidenza',
      icon: highlightedContentSVG,
      group: 'common',
      view: HighlightedContentView,
      edit: HighlightedContentEdit,
      mostUsed: true,
      sidebarTab: 1,
    },
    pagemetadata: {
      id: 'pagemetadata',
      title: 'Data di pubblicazione',
      icon: calendarSVG,
      group: 'common',
      view: PageMetadataView,
      edit: PageMetadataEdit,
      restricted: false,
      mostUsed: false,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },
    pagetag: {
      id: 'pagetag',
      title: 'Tag della pagina',
      icon: tagSVG,
      group: 'common',
      view: PageTagView,
      edit: PageTagEdit,
      restricted: true,
      mostUsed: false,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },
    infobox: {
      id: 'infobox',
      title: 'Box informazione',
      icon: infoSVG,
      group: 'common',
      view: InfoboxView,
      edit: InfoboxEdit,
      restricted: true,
      mostUsed: false,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },
    signedSeparator: {
      ...defaultBlocksConfig,
      id: 'signedSeparator',
      title: 'Separatore con segno grafico',
      icon: signSeparatorSVG,
      group: 'text',
      view: SignedSeparatorView,
      edit: SignedSeparatorEdit,
      sidebarTab: 1,
    },
    slider: {
      ...defaultBlocksConfig,
      id: 'slider',
      title: 'Slider',
      icon: sliderSVG,
      group: 'media',
      view: SliderView,
      edit: SliderEdit,
      sidebarTab: 1,
    },
    imageViewer: {
      ...defaultBlocksConfig,
      id: 'imageViewer',
      title: 'Visualizzatore immagini',
      icon: sliderSVG,
      group: 'media',
      view: ImageViewerView,
      edit: ImageViewerEdit,
      sidebarTab: 1,
    },
    image_columns: {
      ...defaultBlocksConfig,
      id: 'image_columns',
      title: 'Immagini affiancate',
      icon: imageColumnsSVG,
      group: 'media',
      view: ImageColumnsView,
      edit: ImageColumnsEdit,
      sidebarTab: 1,
    },
    imageViewer: {
      ...defaultBlocksConfig,
      id: 'imageViewer',
      title: 'Visualizzatore immagini',
      icon: sliderSVG,
      group: 'media',
      view: ImageViewerView,
      edit: ImageViewerEdit,
      sidebarTab: 1,
    },
    tabs: {
      id: 'tabs',
      title: 'Tabs',
      icon: tabsSVG,
      group: 'text',
      view: TabsView,
      edit: TabsEdit,
      restricted: false,
      mostUsed: false,
      blockHasOwnFocusManagement: true,
      sidebarTab: 1,
      security: {
        addPermission: [],
        view: [],
      },
    },
    testo1: {
      ...defaultBlocksConfig,
      id: 'testo1',
      title: 'Testo 1',
      icon: testo1SVG,
      group: 'text',
      view: Testo1View,
      edit: Testo1Edit,
      blockHasOwnFocusManagement: true,
    },
    testo4: {
      ...defaultBlocksConfig,
      id: 'testo4',
      title: 'Testo 4',
      icon: testo4SVG,
      group: 'text',
      view: Testo4View,
      edit: Testo4Edit,
      blockHasOwnFocusManagement: true,
    },
    testo5: {
      ...defaultBlocksConfig,
      id: 'testo5',
      title: 'Testo 5',
      icon: testo5SVG,
      group: 'text',
      view: Testo5View,
      edit: Testo5Edit,
      blockHasOwnFocusManagement: true,
    },
    testo6: {
      ...defaultBlocksConfig,
      id: 'testo6',
      title: 'Testo 6',
      icon: testo6SVG,
      group: 'text',
      view: Testo6View,
      edit: Testo6Edit,
      blockHasOwnFocusManagement: true,
    },
    testo7: {
      ...defaultBlocksConfig,
      id: 'testo7',
      title: 'Testo 7',
      icon: testo7SVG,
      group: 'text',
      view: Testo7View,
      edit: Testo7Edit,
    },
    break: {
      ...defaultBlocksConfig,
      id: 'break',
      title: 'Interruzione di pagina',
      icon: divideHorizontalSVG,
      group: 'text',
      view: BreakView,
      edit: BreakEdit,
      sidebarTab: 0,
    },
    numbers: {
      ...defaultBlocksConfig,
      id: 'numbers',
      title: 'Numeri',
      icon: numbersSVG,
      group: 'text',
      view: NumbersView,
      edit: NumbersEdit,
      sidebarTab: 1,
    },
    icons_and_numbers: {
      ...defaultBlocksConfig,
      id: 'icons_and_numbers',
      title: 'Icone e numeri',
      icon: iconsNumbersSVG,
      group: 'text',
      view: IconsAndNumbersView,
      edit: IconsAndNumbersEdit,
      sidebarTab: 1,
    },
    icons_and_text: {
      ...defaultBlocksConfig,
      id: 'icons_and_text',
      title: 'Icone e testo',
      icon: iconsAndTextSVG,
      group: 'text',
      view: IconsAndTextView,
      edit: IconsAndTextEdit,
      sidebarTab: 1,
    },
    html: {
      ...config.blocks.blocksConfig.html,
      view: ViewHTMLBlock,
      edit: EditHTMLBlock,
      sidebarTab: 1,
    },
    accordion: {
      ...config.blocks.blocksConfig.accordion,
      group: 'text',
      titleIcons: {
        closed: { leftPosition: rightSVG, rightPosition: downSVG },
        opened: { leftPosition: downSVG, rightPosition: upSVG },
      },
    },
    __grid: {
      ...config.blocks.blocksConfig.__grid,
      mostUsed: false,
      gridAllowedBlocks: ['text', 'image', 'listing', 'video'],
    },

    hero: {
      ...config.blocks.blocksConfig.hero,
      schemaEnhancer: ({ schema, intl, formData }) => {
        addAltText({ schema, intl, formData });
        return schema;
      },
    },

    linked_items: {
      ...defaultBlocksConfig,
      id: 'linked_items',
      title: 'Elementi collegati',
      icon: linkSVG,
      group: 'common',
      view: LinkedItemsView,
      edit: LinkedItemsEdit,
      sidebarTab: 1,
    },
    jobpostingctas: {
      ...defaultBlocksConfig,
      id: 'jobpostingctas',
      title: 'CTA Job Posting',
      icon: linkSVG,
      group: 'common',
      view: JobPostingCTAsView,
      edit: JobPostingCTAsEdit,
      sidebarTab: 1,
      restricted: true,
      mostUsed: false,
      security: {
        addPermission: [],
        view: [],
      },
    },

    job_posting: {
      ...defaultBlocksConfig,
      id: 'job_posting',
      title: 'Listato Job Posting',
      icon: linkSVG,
      group: 'common',
      view: JobPostingView,
      edit: JobPostingEdit,
      sidebarTab: 0,
    },

    listing: {
      ...config.blocks.blocksConfig.listing,
      showLinkMore: true,
      getAsyncData: null, // questo disabilita il ssr dei listing perché rallenta vistosamente la pagina (per ora continuiamo con rendertron)
      variations: [
        ...config.blocks.blocksConfig.listing.variations,
        {
          id: 'simpleCardListing',
          template: SimpleCardListing,
          title: 'Card Semplice',
          isDefault: true,
          schemaEnhancer: ({ schema, formData, intl }) => {
            let pos = getDefaultSchema(schema, formData, intl);
            getSimpleCardVariationSchema(schema, formData, intl, pos);
            return schema;
          },
        },
        {
          id: 'newsCardListing',
          isDefault: false,
          title: 'Card News',
          template: NewsCardListing,
          schemaEnhancer: ({ schema, formData, intl }) => {
            let pos = getDefaultSchema(schema, formData, intl);
            getNewsCardVariationSchema(schema, formData, intl, pos);
            return schema;
          },
        },
        {
          id: 'photogalleryListing',
          isDefault: false,
          title: 'Photogallery',
          template: PhotogalleryListing,
          schemaEnhancer: ({ schema, formData, intl }) => {
            let pos = getDefaultSchema(schema, formData, intl);
            getPhotogalleryVariationSchema(schema, formData, intl, pos);
            return schema;
          },
        },
        {
          id: 'mosaicCardListing',
          isDefault: false,
          title: 'Mosaic Card Listing',
          template: MosaicCardListing,
          schemaEnhancer: ({ schema, formData, intl }) => {
            let pos = getDefaultSchema(schema, formData, intl);
            getMosaicVariationSchema(schema, formData, intl, pos);
            return schema;
          },
        },
        {
          id: 'downloadListing',
          isDefault: false,
          title: 'Download',
          template: DownloadListing,
          schemaEnhancer: ({ schema, formData, intl }) => {
            let pos = getDefaultSchema(schema, formData, intl);
            getDownloadVariationSchema(schema, formData, intl, pos);
            return schema;
          },
        },
        {
          id: 'searchResults',
          isDefault: false,
          title: 'Risultati di ricerca',
          template: SearchResults,
          schemaEnhancer: ({ schema, formData, intl }) => {
            let pos = getDefaultSchema(schema, formData, intl);
            getSearchResultsVariationSchema(schema, formData, intl, pos);
            return schema;
          },
        },
        // {
        //   id: 'jobpostingListing',
        //   isDefault: false,
        //   title: 'Job Posting',
        //   template: JobPostingListing,
        //   schemaEnhancer: ({ schema, formData, intl }) => {
        //     let pos = getDefaultSchema(schema, formData, intl);
        //     getJobPostingVariationSchema(schema, formData, intl, pos);
        //     return schema;
        //   },
        // },
        // {
        //   id: 'example-variation',
        //   isDefault: true,
        //   title: 'Example',
        //   template: ExampleVariation,
        //   schemaEnhancer: ({ schema, formData, intl }) => {
        //     let pos = getDefaultSchema(schema, formData, intl);
        //     getExampleVariationSchema(schema, formData, intl, pos);
        //     return schema;
        //   },
        // },
      ],
    },
  };

  updateSearchBlockExtensions(config);

  removeListingVariation(config, 'default');
  removeListingVariation(config, 'imageGallery');
  removeListingVariation(config, 'summary');
  delete config.blocks.blocksConfig.toc; //remove block 'indice dei contenuti'
  delete config.blocks.blocksConfig.teaserGrid; //remove block 'teaserGrid'
  delete config.blocks.blocksConfig.imagesGrid; //remove block 'imagesGrid'

  config.blocks.requiredBlocks = [
    'breadcrumbs',
    'author',
    'infobox',
    'pagetag',
  ]; //il blocco 'title' non è required perchè al suo posto possono mettere il blocco slider
  config.blocks.initialBlocks = {
    ...config.blocks.initialBlocks,
    Document: ['breadcrumbs', 'title', 'related_items', 'pagetag'],
    Event: ['breadcrumbs', 'title', 'infobox', 'related_items', 'pagetag'],
    Project: ['slider', 'breadcrumbs', 'title'],
    Story: ['slider', 'breadcrumbs', 'title', 'author', 'related_items'],
    'News Item': ['slider', 'breadcrumbs', 'title', 'related_items', 'pagetag'],
    JobPosting: ['slider', 'breadcrumbs', 'text', 'jobpostingctas'],
    Folder: ['breadcrumbs', 'title', 'text'],
  };
  config.blocks.initialBlocksFocus = {
    ...config.blocks.initialBlocksFocus,
    Document: 'title',
    Event: 'title',
    Project: 'title',
    Story: 'title',
    'News Item': 'title',
    JobPosting: 'slider',
    Folder: 'title',
  };
};
